import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import styled from '@xstyled/styled-components';
import { Table } from 'antd';
import { useMemo } from 'react';
import { renderColumns } from '../columns';
import { styleVariables } from '@lib/common';
import { jsx as _jsx } from "react/jsx-runtime";
var StyledTable = styled(Table)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin-bottom: 20px;\n  .ant-table-thead > tr > th {\n    background: ", ";\n  }\n  .ant-table-container table {\n    & > tbody > tr > td {\n      cursor: pointer;\n    }\n  }\n"])), styleVariables.colors.gray3);
export var TableViolate = function TableViolate(_ref) {
  var _submission$securityT;

  var submission = _ref.submission,
      violateTranslation = _ref.violateTranslation;
  var securityTracings = (_submission$securityT = submission === null || submission === void 0 ? void 0 : submission.securityTracings) !== null && _submission$securityT !== void 0 ? _submission$securityT : [];
  var columns = useMemo(function () {
    return renderColumns(violateTranslation);
  }, [violateTranslation]);

  if (securityTracings.length === 0) {
    return null;
  }

  return /*#__PURE__*/_jsx(StyledTable, {
    bordered: true,
    dataSource: securityTracings,
    columns: columns,
    pagination: false
  });
};